.base-underlying-badge.badge-outline-warning {
  outline: 0;
}

.base-underlying-badge.badge-default {
  background-color: var(--bs-bg-lvl1);
}

.base-underlying-badge::before {
  display: none !important;
}
